import { Stack, SimpleGrid, Group, Button } from "@mantine/core";
import { FieldRenderer } from "../FieldRenderer";
import { ImageUploader } from "../ImageUploader";
import { PrivacyConsent } from "../PrivacyConsent";
import { TurnstileCaptcha } from "../TurnstileCaptcha";

export const DynamicFormForm = ({
    onSubmit,
    visibleFields,
    register,
    control,
    errors,
    watch,
    setValue,
    countryCode,
    photos,
    onImagesChange,
    imageErrors,
    privacyConsent,
    onPrivacyConsentChange,
    privacyError,
    siteConfig,
    onTurnstileSuccess,
    onTurnstileError,
    onTurnstileExpire,
    loading,
    onReset,
    canSubmit,
    layout,
}) => {
    return (
        <form noValidate onSubmit={onSubmit} className="form-layout form-layout--vertical">
            <Stack gap={layout.fields.gap}>
                <SimpleGrid cols={layout.fields.columns} spacing={layout.fields.gap}>
                    {visibleFields.map((field) => (
                        <FieldRenderer
                            key={field.name}
                            field={field}
                            register={register}
                            control={control}
                            errors={errors}
                            watchedValue={watch(field.name)}
                            setValue={setValue}
                            countryCode={countryCode}
                            conversions={layout.conversions}
                            segmentedVariant={layout.fields.segmentedVariant}
                            socialVariant={layout.fields.socialVariant}
                            phoneVariant={layout.fields.phoneVariant}
                        />
                    ))}
                </SimpleGrid>

                {photos && photos.length > 0 && (
                    <ImageUploader
                        photos={photos}
                        onImagesChange={onImagesChange}
                        errors={imageErrors}
                        columns={layout.photos.columns}
                        gap={layout.photos.gap}
                    />
                )}

                <PrivacyConsent
                    checked={privacyConsent}
                    onChange={onPrivacyConsentChange}
                    error={privacyError}
                    siteConfig={siteConfig}
                    renderAs={layout.fields.privacyVariant}
                />

                <Group justify="space-between" align="center" mt="md" wrap="wrap">
                    <TurnstileCaptcha
                        siteKey={siteConfig?.turnstileSiteKey}
                        onSuccess={onTurnstileSuccess}
                        onError={onTurnstileError}
                        onExpire={onTurnstileExpire}
                    />
                    <Group gap="sm">
                        <Button variant="outline" onClick={onReset} disabled={loading}>
                            Reset
                        </Button>
                        <Button type="submit" loading={loading} disabled={!canSubmit}>
                            Submit
                        </Button>
                    </Group>
                </Group>
            </Stack>
        </form>
    );
};
